import { useMemo } from "react";
import styles from "./theming-form-container.less";

type ThemingFormContainerProps = {
    children: React.ReactNode | Array<React.ReactNode>;
    forceMaxWidth?: boolean;
};

export const ThemingFormContainer = (props: ThemingFormContainerProps) => {
    const { children, forceMaxWidth } = props;
    
    const className = useMemo(() => {
        return forceMaxWidth ? styles.maxWidthThemingFormContainer : styles.themingFormContainer;
    }, [forceMaxWidth]);

    return (
        <div className={className}>
            {children}
        </div>
    );
};